export class EmployeeModel {
  EmployeeId: string;
  CompanyUserId: number;
  CompanyId: string;
  UserName: string;
  EmailAddress: string;
  PhoneNumber: string;
  PasswordHash: string;
  PasswordStatus: number;
  LastPasswordChangeDate: Date;
  RFC: string;
  CURP: string;
  CellPhoneNumber: string;
  EmployeeStatus: number;
  SecurityCode: string;
  LastName1: string;
  LastName2: string;
  FirstName: string;
  HasContractToSign: boolean;
  Question1: string;
  Answer1: string;
  Question2: string;
  Answer2: string;
  Question3: string;
  Answer3: string;
}



// WEBPACK FOOTER //
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/models/employee.model.ts